<template>
  <v-card :class="[mapSidePanelClasses, panelState]" flat>
    <transition name="fade">
      <button v-show="panelState" @click="closePanel()" class="panel-close">
        <v-icon color="#2A2929">mdi-close</v-icon>
      </button>
    </transition>
    
    <div class="card-wrapper">
      <div class="px-4 pl-md-8 pr-md-6 mb-8">
        <p class="text--headline-4 mb-2">{{ selectedEl.name }}</p>

        <!-- <span class="card-button text--body-4 mb-4" :style="{ backgroundColor: categoryColor }">{{ selectedEl.context }}</span> -->

        <div class="card-city-name mb-2">
          <img src="@/assets/icons/map-panel-location-icon.svg" />
          <div>
            <p class="text--caption font-weight-bold text--seed-jade mb-1">{{ selectedEl.country }}</p>
            <p class="text--caption mb-0 font-italic">{{ selectedEl.address }}</p>            
          </div>
        </div>

        <div class="card-city-name mb-2" v-if="selectedEl.website">
          <img src="@/assets/icons/map-panel-globe-icon.svg" style="vertical-align: middle" />
          <div>
            <p class="text--caption text--seed-jade mb-0">Visit their website <a :href="selectedEl.website" target="_blank">here</a></p>    
          </div>
        </div>
      </div>

      <div class="mb-6" v-if="selectedEl.image">
        <img :src="selectedEl.image" width="100%" height="auto" />
      </div>

      <div class="px-4 pl-md-8 pr-md-6 card-city-desc">
        <p class="text--body-2 text--seed-jade mb-2 font-weight-bold">Description</p>
        <!-- {{selectedEl}} -->
        <p class="text--body-3">{{ selectedEl.desc_1 }}</p>
        <p class="text--body-3" v-if="selectedEl.desc_2">{{ selectedEl.desc_2 }}</p>
        <p class="text--body-3" v-if="selectedEl.desc_3">{{ selectedEl.desc_3 }}</p>

      </div>      

      <!-- <div class="px-4 pl-md-8 pr-md-6">
        <p class="text--body-2 text--seed-jade mb-2 font-weight-bold">Climate notes</p>
        <p class="text--body-3 mb-0">{{ selectedEl.climate_notes }}</p>
      </div> -->
    </div>
  </v-card>
</template>

<script>
import _kebabCase from 'lodash.kebabcase';

export default {
  name: 'MapSidePanel', 
  props: {
    panelState: {
      type: String,
      required: true,
    },
    selectedEl: {
      type: Object,
      required: true,
      default: () => {
        return { message: 'hello' }
      }
    },
  },
  computed: {
    mapSidePanelClasses() {
      return {
        'map-side-panel--desktop map-side-panel': this.$vuetify.breakpoint.mdAndUp,
        'map-side-panel--mobile map-side-panel py-6': this.$vuetify.breakpoint.smAndDown,
      };
    },
    categoryColor() {
      const legend = {
        'Community': '#E9DAF0',
        'Enterprise': '#E3E70A',
        'Family farm': '#F2BB47',
        'Individual': '#BBCCE8',
        'Non-profit organisation': '#FBC7B5',
        'Organisation': '#8AD3AF',
        'Research institute': '#E2D291',
      };

      return legend[this.selectedEl.context]
    }
  },  
  watch: {
    selectedEl() {
      document.querySelector('.map-side-panel').scrollTo(0,0);
    },    
  },
  methods: {
    closePanel() {
      document.querySelector('.map-side-panel').scrollTo(0,0);
      document.querySelector('.map-side-panel').classList.remove("--is-open"); 
      this.$emit('update-panel', '');
      this.$emit('reset-map', '');
    },      
    kebabCase(string) {
      return _kebabCase(string)
    }       
  },
}
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/settings/_variables.scss';

.map-side-panel {
  position: fixed;
  z-index: 10;
  background-color: #FAF7F5;
  border-radius: unset;

  // scrollbar
  overflow-y: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */ 
  &::-webkit-scrollbar {
    display: none;    
  }

  .card-wrapper {
    position: relative;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */ 
    &::-webkit-scrollbar {
      display: none;    
    }    
  }

  .panel-close {
    position: fixed;
    top: 16px;
    left: calc((4 / 12 * 100vw) - 36px);
    border-radius: 50% !important;
    background-color: rgba(250, 250, 250, 0.72);
    padding: 4px;
    margin-right: 8px;
    z-index: 15;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      right: 8px;
      top: unset;
      left: unset;
      bottom: calc(60vh - 40px);
    }
  }    

  div.card-city-name {
    div {
      display: inline-block;
      width: 90%;
    }

    img {
      display: inline-block;
      vertical-align: top;
      margin-right: 8px;
    }
  }

  div.card-city-desc {
    p {
      margin-bottom: 8px;
    }
    p:last-child {
      margin-bottom: 0 !important;
    }
  }

  span.card-button {
    padding: 8px;
    border-radius: 8px;
    display: inline-block;
  }

}

.map-side-panel--desktop {
  max-width: calc(4 / 12 * 100vw);
  width: calc(4 / 12 * 100vw);
  height: 100vh;
  max-height: 100vh;
  top: 0;
  left: calc(-4 / 12 * 100vw);
  transition: left 0.5s ease 0s;  
  padding-top: 72px;
  padding-bottom: 36px;
  
  &.--is-open {
    left: 0;
    transition: left 0.5s ease 0s;  
  }
}

.map-side-panel--mobile {
  width: 100%; 
  max-height: 60vh;
  height: 60vh;
  bottom: -60vh;
  left: 0;
  padding-top: 48px !important;
  padding-bottom: 64px;  
  transition: bottom 0.5s ease 0s;  
  
  &.--is-open {
    bottom: 0;
    transition: bottom 0.5s ease 0s;  
  }
}

.fade-leave-active {
  transition: opacity 0s;
}

.fade-enter-active{
  transition: opacity 2.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>